import axios from "axios";
//import Csrf from "./Csrf";
import store from "../store";

let Api = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/api`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
  transformRequest: [function (data, headers)
  {
    const clientUid = store.getters.clientUid;
    const roles = store.getters.roles;
    const requestData = data instanceof FormData ? data : JSON.stringify(data);

    if (clientUid && (roles.includes("moder") || roles.includes("admin"))) {
      headers.hasOwnProperty("client") ? null : headers["client"] = clientUid;
    }

    return requestData;
  }]
});
let ModerApi = axios.create({
  baseURL: `http://localhost/pm.api_dev/public/api`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
});

Api.defaults.withCredentials = true;
ModerApi.defaults.withCredentials = true;

export {
  Api,
  ModerApi
};
